<template>
  <div>

    <el-tabs 
      type="border-card" 
      v-model='temp' 
      vs.height='H-74'
      @tab-click='' >

      <el-tab-pane label="普通用户" name=''>
         
      </el-tab-pane>
      
      <el-tab-pane label="内置用户" name=''>
        
      </el-tab-pane>

    </el-tabs> 

  </div>
</template>

<script>

export default {
  data() {
    return {


    };
  },
  
  watch: {

  },

  methods: {


  },

  created() {


  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/$MyTabs.vue